module.exports = __webpack_public_path__ + "static/media/magic-wand-active.ce5fb9e1.png";